import { Navigate, Route, Routes, useParams } from "react-router-dom";

import AppShell from "./components/layout/AppShell";
import AuthLayout from "./components/layout/AuthLayout";
import PlainAppShell from "./components/layout/PlainAppShell";


import DoctorListing from "./pages/DoctorListing";
import Insurance from "./pages/InsuranceList";
import InsuranceSubmit from "./pages/InsuranceSubmit";
import NotFound from "./pages/NotFound";
import Confirmation from "./pages/PatientBookingConfirmation";
import PatientDashboard from "./pages/patient/PatientDashboard";

import Settings from "./pages/Settings";
import PatientLogin from "./pages/SignIn";
import PatientSignup from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import BookAppointment from "./pages/patient/BookAppointment";
import PatientAppointments from "./pages/patient/PatientAppointments";
import PatientAppointmentDetail from "./pages/patient/PatientAppointmentDetail";
import PatientNotifications from "./pages/patient/PatientNotifications";
import AIAssistantChat from "./pages/patient/AIAssistantChat";
import PatientInvoices from "./pages/patient/PatientInvoices";
import PatientSettings from "./pages/patient/PatientSettings";
import PatientTickets from "./pages/patient/PatientTickets";
import PatientRaiseTicket from "./pages/patient/PatientRaiseTicket";
import PatientTicketDetail from "./pages/patient/PatientTicketDetail";
import Doctors from "./pages/patient/Doctors";
import DoctorDetail from "./pages/patient/DoctorDetail";
import DoctorChat from "./pages/patient/DoctorChat";
import DoctorReports from "./pages/patient/DoctorReports";
import DoctorRequests from "./pages/patient/DoctorRequests";
import DoctorAppointments from "./pages/patient/DoctorAppointments";

// Stale appointment URLs from earlier pages land on the canonical routes.
function AppointmentDetailRedirect() {
  const { appointmentId } = useParams();
  return <Navigate to={`/patient/appointments/${encodeURIComponent(appointmentId || "")}`} replace />;
}

export default function App() {
  return (
    <Routes>
      {/* Default */}
      <Route path="/" element={<Navigate to="/signin" replace />} />

      {/* AUTH ROUTES (common layout) */}
      <Route element={<AuthLayout />}>
        {/* Patient */}
        <Route path="/signin" element={<PatientLogin />} />
        <Route path="/signup" element={<PatientSignup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/patient/forgot-password" element={<ForgotPassword />} />
      </Route>

      <Route element={<PlainAppShell />}>
        {/* <Route path="/patient/doctors" element={<DoctorListing />} /> */}
        <Route path="/patient/confirmation" element={<Confirmation />} />
        <Route path="/patient/insurance/submit" element={<InsuranceSubmit />} />

        {/* add more routes without sidebar here */}
      </Route>

      {/* APP ROUTES (post-login shell layout) */}
      <Route element={<AppShell />}>
        <Route path="/patient/dashboard" element={<PatientDashboard />} />
        <Route path="/patient/insurance" element={<Insurance />} />
        <Route path="/patient/invoices" element={<PatientInvoices />} />
        <Route path="/patient/settings" element={<PatientSettings />} />
        {/* Legacy support URLs land on the real ticket pages. */}
        <Route path="/patient/support" element={<Navigate to="/patient/tickets" replace />} />
        <Route path="/patient/support/create" element={<Navigate to="/patient/tickets" replace />} />
        {/* The retired checkout page used a hardcoded Stripe test Payment Link.
            Payment now starts only after an appointment is reserved, through the
            Patient API, which returns the account-specific Checkout Session URL. */}
        <Route path="/patient/checkout" element={<Navigate to="/patient/book-appointment" replace />} />
        <Route path="/patient/book-appointment" element={<BookAppointment />} />
        <Route path="/patient/appointments" element={<PatientAppointments />} />
        <Route path="/patient/appointments/:appointmentId" element={<PatientAppointmentDetail />} />
        <Route path="/patient/my-appointments" element={<Navigate to="/patient/appointments" replace />} />
        <Route path="/patient/appointment/:appointmentId" element={<AppointmentDetailRedirect />} />
        <Route path="/patient/appointment-video/:appointmentId" element={<AppointmentDetailRedirect />} />
        {/* AVIA is authenticated and canonical at /patient/ai-assistant (Task 4).
            /patient/book and the old AI results page redirect inside this guarded shell. */}
        <Route path="/patient/book" element={<Navigate to="/patient/ai-assistant" replace />} />
        <Route path="/patient/ai-appointment-results" element={<Navigate to="/patient/ai-assistant" replace />} />
        <Route path="/patient/notifications" element={<PatientNotifications />} />
        <Route path="/patient/ai-assistant" element={<AIAssistantChat />} />
        <Route path="/patient/tickets" element={<PatientTickets />} />
        <Route path="/patient/tickets/new" element={<PatientRaiseTicket />} />
        <Route path="/patient/tickets/:ticketId" element={<PatientTicketDetail />} />
        <Route path="/patient/doctors" element={<Doctors />} />
<Route path="/patient/doctors/:doctorId" element={<DoctorDetail />} />
<Route path="/patient/doctors/:doctorId/appointments" element={<DoctorAppointments />} />
<Route path="/patient/doctors/:doctorId/chat" element={<DoctorChat />} />
<Route path="/patient/doctors/:doctorId/reports" element={<DoctorReports />} />
<Route path="/patient/doctor-requests" element={<DoctorRequests />} />
        
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
